module.exports = __webpack_public_path__ + "img/formsTrapezGS.5943f593.svg";